<template>
    <span class="centix-vue-textinput holder-span">
        <input autocomplete="off" class="search-input" ref="inputItem" type="text" v-model="searchKey" v-on:keyup.enter="onReturn($event)" v-on:keyup.esc="$event.target.blur()" @blur="onblur" v-on:input="onInput($event)" v-bind:placeholder="placeholder" v-bind:disabled="disabled">
        <a class="clear-button" v-if="hasValue" v-on:click.prevent="clearForm()"></a>
    </span>
</template>

<script>
import 'vue';

export default {
  name: 'TextInput',
  props: {
    textValue: String,
    placeholder: String,
    disabled: Boolean
  },
  data: function () {
    var self = this;
    return {
      searchKey: self.textValue || ''
    };
  },
  methods: {
    clearForm: function () {
      this.searchKey = '';
      this.$emit('input', this.searchKey);
    },
    onReturn: function (e) {
      this.$emit('returned', this.searchKey);
    },
    onInput: function (e) {
      this.$emit('input', this.searchKey);
    },
    focus: function () {
      this.$refs.inputItem.focus();
    },
    select: function () {
      this.$refs.inputItem.select();
    },
    onblur: function () {
      this.$emit('blur', '');
    }
  },
  computed: {
    hasValue () {
      return this.searchKey != null && this.searchKey.length > 0;
    }
  },
  watch: {
    textValue () {
      // object changed from outside the component
      this.searchKey = this.textValue;
    },
    searchKey () {
      this.$emit('update:textValue', this.searchKey);
    }
  }
};
</script>

<style lang="scss">
.centix-vue-textinput {
    &.holder-span {
    position: relative;
    display: block;
    input {
      padding-right: 25px;
      width: 100%;
    }
  }
  .clear-button {
    position: absolute;
    right: 0;
    top: 0;
    background: url('../assets/remove.png') no-repeat center right 12px;
    background-size: 12px 12px;
    width: 40px;
    height: 100%;
    cursor: pointer;
  }
}
</style>
